import moment from 'moment';
import _ from 'lodash';

export default function getNumberOfLastDays(daysNumber) {
    return _.times(daysNumber, i => i === 0 ? moment() : moment().subtract(i, 'd'));
}
